// Общие вещи импорта/экспорта KML зон доставки.

export const KML_FORMATS = [
  {
    value: 'fakt',
    title: 'ФАКТ',
    text: 'Для правки в Яндекс.Конструкторе и обратной загрузки: зоны узнаются по служебной метке в описании.',
  },
  {
    value: 'jupiter',
    title: 'Юпитер',
    text: 'Как текущая база в конструкторе: название зоны в описании, цвет по номеру зоны, филиал по началу названия.',
  },
]

// zones-fakt-all-2026-10-15_09-30.kml - тот же шаблон, что у бэка (ZonesExporter::fileName)
export function kmlFileName (format, scope, filialIds, now = new Date()) {
  const pad = (n) => String(n).padStart(2, '0')
  const stamp =
    now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate()) +
    '_' + pad(now.getHours()) + '-' + pad(now.getMinutes())
  const scopePart = scope === 'all' ? 'all' : (filialIds || []).length + '-filials'
  return `zones-${format}-${scopePart}-${stamp}.kml`
}

export function saveBlob (blob, fileName) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

// Ошибка запроса с responseType blob: тело ответа - Blob с JSON внутри
export async function blobErrorMessage (e) {
  const data = e && e.response && e.response.data
  if (data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text())
      return json.fullErrorMessage || json.message || 'Не удалось выгрузить файл'
    } catch (_) {
      return 'Не удалось выгрузить файл'
    }
  }
  return (e && e.message) || 'Не удалось выгрузить файл'
}

export const KML_WARNINGS = {
  ring_closed: 'Контур не был замкнут - замкнули сами',
  inner_rings_ignored: 'Вырезы внутри полигона не поддерживаются - взят внешний контур',
  too_few_points: 'Меньше трёх точек - пропущен',
  multigeometry_skipped: 'Составной объект из нескольких фигур - пропущен',
  bad_coordinates: 'Неверные координаты - пропущен',
  not_polygon: 'Не полигон (линия или другой объект) - пропущен',
  filial_not_in_file: 'В файле нет зон филиала - его зоны не изменятся',
}
